var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${
    _vm.sectionData.class !== undefined
      ? _vm.sectionData.class
      : 'q-px-md html-component'
  }`,style:(`${_vm.sectionData.style !== undefined ? _vm.sectionData.style : ''}`),domProps:{"innerHTML":_vm._s(_vm.sectionData.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }